<template>
    <div>
        <template>
            <v-row justify="center">
                <custom-popup v-model="showPlus"
                              max-width="900"
                              hide-overlay
                              :cons="cons"
                              transition="dialog-bottom-transition"
                              hide-confirm>
                    <v-card>
                        <add-new :transactionsCount="transactionCount" :modal="()=>{showPlus=false}"
                                 :reqAgain="()=>{reqAgain}" :id="addPeyment"></add-new>
                    </v-card>
                </custom-popup>
            </v-row>
        </template>

        <div v-if="Object.keys(archives).length > 0">
            <div class="col-md-12 row py-10">
                <div class="col-md text-center">
                    <div class="row mx-auto px-0">

                        <p class="col-md py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">نام مجموعه :</span>
                            {{ archives.name }}
                        </p>
                        <p class="col-md py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">مبلغ کلی سفارش :</span>
                            {{ archives.price | currency |persianNum }} ﷼
                        </p>

                    </div>
                    <div class="row mx-auto justify-center">
                        <p class="mx-auto pt-3 font-weight-bold" style="color: #1c0152">مبلغ مانده سفارش </p>
                        <p class="mx-auto pt-3">{{ archives.remain_money | currency |persianNum }} ﷼</p>
                        <v-btn v-if="archives.transactions.length === 1" :disabled="archives.status==='paid' || admin"
                               small
                               @click="payOnce(archives.transactions[0].payment_id ,archives.transactions[0].id)"
                               class="btn-payment mx-auto">
                            <span class="fa fa-dollar-sign ml-1" style="font-size: 1.3rem"></span>
                            پرداخت یکجا
                        </v-btn>
                        <v-btn v-else :disabled="archives.status==='paid' || admin" small
                               @click="payFinal(archives.transactions[0].payment_id)" class="btn-payment mx-auto">
                            <span class="fa fa-dollar-sign ml-1" style="font-size: 1.3rem"></span>
                            پرداخت کل اقساط
                        </v-btn>
                    </div>
                    <div class="row mx-auto" v-if="archives.price > item.price"
                         v-for="(item,index) in archives.transactions" :key="item.payment_id">
                        <p class="mx-auto pt-3 font-weight-bold" style="color: #1c0152">{{ item.description }}</p>
                        <p class="mx-auto pt-3 font-weight-bold" style="color: #1c0152"> آخرین مهلت پرداخت
                            : {{ jalalian(item.expired_at) }}</p>
                        <p class="mx-auto pt-3">{{ item.price|currency|persianNum }} ﷼</p>
                        <v-btn small @click="installment(item.id,item.payment_id)"
                               :disabled="item.status==='paid' || admin"
                               class="btn-payment mr-auto">
                            <span class="fa fa-dollar-sign ml-1 " style="font-size: 1.2rem"></span>
                            پرداخت
                        </v-btn>
                    </div>
                    <div class="row mx-auto text-right text-justify mt-10 px-15">
                        <v-expansion-panels v-if="extraDesc.length > 0 && !admin">
                            <v-expansion-panel class="my-1" v-for="(item,index) in extraDesc" :key="index">
                                <v-expansion-panel-header>
                                    <span style="color: #1c0152" class="font-weight-bold">{{
                                            item.title !== null ? item.title : 'توضیحات'
                                        }} </span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p v-for="(line) in item.desc.split('\n')" class="mx-auto">
                                        {{ line }}</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels v-if="extraDesc.length > 0 && admin">
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <span style="color: #1c0152" class="font-weight-bold">توضیحات </span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div class="col-md-12 mx-0 text-left mb-2"
                                         style="border: 1px solid lightgray;border-radius: 10px"
                                         v-for="(item,index) in extraDesc" :key="index">
                                        <v-btn icon v-if="extraDesc.length>1" small
                                               @click="removeDesc(extraDesc[index])"
                                               color="red">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                        <div class="col-md-12 mx-0  ">
                                            <v-text-field outlined label="عنوان" v-model="item.title" dense clearable
                                                          prepend-inner-icon="fa fa-pencil-alt"></v-text-field>
                                            <v-textarea :key="index" v-model="item.desc" outlined
                                                        :label="' ویرایش توضیحات ' + Number(index+1)"></v-textarea>
                                            <v-btn @click="newDesc"
                                                   class="btn-add-with-text py-3 col-md-11 mr-6">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>


                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

            </div>
            <div class="col-md-12 row py-10" v-if="admin && archives.transactions.length > 0">
                <v-row class="col-md-12 mx-auto">
                    <v-col class="text-right"
                           cols="12"
                           md="6">
                        <v-btn @click="Delete" class="btn-delete">
                            <i class="fa fa-trash-alt"></i>
                            حذف تمامی اقساط
                        </v-btn>
                    </v-col>
                    <v-col class="text-right"
                           cols="12"
                           md="6">
                        <v-btn @click="showPlus=true" class="btn-add-with-text">
                            <v-icon>mdi-plus</v-icon>
                            اضافه کردن قسط جدید
                        </v-btn>
                    </v-col>
                </v-row>
                <v-col
                        class="col-md text-right"
                        cols="12"
                        md="6"
                >
                    <v-text-field
                            outlined
                            label="مبلغ کل"
                            dense
                            disabled
                            v-model="main_price"
                            clearable
                            suffix="﷼"
                            @keypress="allowOnlyNumbers"
                            clear-icon="mdi-close-circle"
                            prepend-inner-icon="fa fa-pencil-alt"
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field
                            outlined
                            label="تعداد اقساط"
                            dense
                            disabled
                            v-model="count"
                            clearable
                            @keypress="allowOnlyNumbers"
                            clear-icon="mdi-close-circle"
                            prepend-inner-icon="fa fa-pencil-alt"
                    ></v-text-field>
                </v-col>
                <v-col
                        class="text-right"
                        cols="12"
                        md="12"
                >
                </v-col>
                <v-row v-for="(item,index) in archives.transactions"
                       class="px-5 ">
                    <v-col
                            class="text-right"
                            cols="12"
                            md="6"
                    >
                        <v-text-field
                                outlined
                                :label="' مبلغ قسط ' + Number(index +1) "
                                dense
                                :disabled="item.status=== 'paid' "
                                clearable
                                :value="item.price | currency"
                                @input="priceIs(item,$event)"
                                @keypress="allowOnlyNumbers"
                                clear-icon="mdi-close-circle"
                                prepend-inner-icon="fa fa-pencil-alt"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col class="text-right"
                           cols="12"
                           md="6">
                        <date-picker
                                v-model="item.expired_at"
                                color="#00acc1"
                                label="تاریخ پرداخت"
                                input-class="mb-0 rounded"
                                persianDigits
                                clearable
                                :disabled="item.status=== 'paid' "
                                :timezone="false"
                                format="YYYY-MM-DD"
                                style="font-size: 13px!important"
                                class="dateSet my-2"
                                display-format="jMMMM jD"
                        />
                    </v-col>
                </v-row>

                <v-col class="text-right"
                       cols="12"
                       md="12">
                    <div class="text-center">
                        <p>مبلغ قابل پرداخت در هر قسط : <span
                                class="text-primary">{{
                                countPrice|currency|persianNum
                            }} ﷼ </span>
                        </p>
                    </div>
                </v-col>

                <v-col cols="12" md="12">
                    <v-btn @click="update" class="submit-btn float-left">
                        <span class="fa fa-save ml-1" style="font-size: 1.5rem"></span>
                        ثبت تغییرات
                    </v-btn>
                </v-col>

            </div>
        </div>
        <div class="col-md-6 py-10 mx-auto" v-else>
            <p class="text-center">در حال بارگیری اطلاعات</p>
            <v-progress-linear
                    indeterminate
                    height="5"
                    striped
                    color="indigo"
            ></v-progress-linear>
        </div>
    </div>
</template>


<script>

import {createFormData} from "@/Utilities/FormRequestHelper";
import AddNew from "../admin/addNew";
import CustomPopup from "../../../core/plugins/TitleRibbon/plugins/popup/customPopup";

export default {
    name: "payPage",
    components: {CustomPopup, AddNew},
    props: {
        archives: {
            default: {}
        },
        admin: {
            default: false
        },
        modal: {
            default: () => {
            },
            type: Function
        },
        reqAgain: {
            default: () => {
            },
            type: Function
        },
        addPeyment: {
            default: ''
        },
        transactionCount: {
            default: ''
        },
    },
    data() {
        return {
            loading: false,
            cons: {title: 'اطلاعات درخواست'},
            showPlus: false,
            status: 'accept',
            count: '',
            decsCount: 1,
            days: {},
            extraDesc: [],
            mainPrice: '',
            selectedTochange: '',
            chosenId: '',
        }
    },
    methods: {
        removeDay(id) {
            this.days.splice(id, 1)
        },
        payOnce(id, transactionId) {
            this.$modal.showLoading();
            this.requestApiPost(`payment/${id}/pay`, {
                transaction_id: transactionId
            }).then((response) => {
                this.$modal.hideLoading();
                this.$nextTick(() => {
                    this.$toast.success('پرداخت شما با موفقیت انجام شد.');
                });
                this.reqAgain();
                this.modal();
            }).catch(() => {
                this.$nextTick(() => {
                    this.$modal.error('پرداخت با خطا مواجه شد.');
                });
            })
        },
        payFinal(id) {
            this.$modal.showLoading();
            this.requestApiPost(`payment/${id}/pay`, {
                oncePayment: true
            }).then((response) => {
                this.$modal.hideLoading();
                btn - outline - danger
                this.$nextTick(() => {
                    this.$toast.success('پرداخت شما با موفقیت انجام شد.');
                });
                this.reqAgain();
                this.modal();
            }).catch(() => {
                this.$nextTick(() => {
                    this.$modal.error('پرداخت با خطا مواجه شد.');
                });
            })
        },
        update() {

            const transactions = [];
            let sum = 0;

            this.archives.transactions.filter((x,index) => {
                const item = {
                    'transaction_id': x.id,
                    'description':' قسط ' + Number(index+1),
                    'expired_at': x.expired_at,
                    'price': Number(x.price),
                };
                sum += Number(x.price);
                transactions.push(item);
            });

            if (sum < this.archives.remain_money) {
                this.$toast.error('اقساط وارد شده از مبلغ باقی مانده کمتر است.')
            } else if (sum > this.archives.remain_money) {
                this.$toast.error('اقساط وارد شده از مبلغ باقی مانده بیشتر است.')
            } else {
                this.$modal.showLoading();
                this.requestApiPost('admin/form/update', JSON.stringify({
                    transactionArray: transactions,
                    description: this.extraDesc

                })).then((response) => {
                    this.$modal.hideLoading();
                    this.$nextTick(() => {
                        this.$toast.success('اقساط شما با موفقیت ویرایش شد.');
                    });
                    this.reqAgain();
                    this.modal();
                }).catch(() => {
                    this.$nextTick(() => {
                        this.$modal.error('ویرایش اقساط با خطا مواجه شد.');
                    });
                })
            }
        },
        installment(id, transactionID) {
            this.$modal.showLoading();
            this.requestApiPost(`payment/${transactionID}/pay`, {
                transaction_id: id
            }).then(() => {
                this.$modal.hideLoading();
                this.$nextTick(() => {
                    this.$toast.success('پرداخت شما با موفقیت انجام شد.');
                });
                this.reqAgain();
                this.modal();
            }).catch(() => {
                this.$nextTick(() => {
                    this.$modal.error('پرداخت با خطا مواجه شد.')
                });
            })
        },
        day() {
            this.count = this.archives.transactions.length
        },
        saveChange(id, index) {
            this.selectedTochange = this.days[index];
            this.chosenId = id
        },
        Delete() {

            this.$modal.yesNo('تایید حذف اقساط', 'آیا از حذف اقساط خود اطمینان دارید؟').then((value) => {
                if (value === true) {
                    this.$modal.showLoading();
                    this.requestApiPost('admin/form/delete', {
                        payment_id: this.archives.transactions[0].payment_id
                    }).then((response) => {
                        this.$modal.hideLoading();
                        this.$nextTick(() => {
                            this.$toast.success('اقساط با موفقیت حذف شدند.');
                        });
                        this.reqAgain();
                        this.modal();
                    })
                }
            })


        },
        priceIs(transaction, value) {
            this.archives.transactions[this.archives.transactions.indexOf(transaction)].price = Number(value.replaceAll(",", ""));
        },
        newDesc() {
            this.extraDesc.push({
                title: '',
                desc: ''
            })
        },
        removeDesc(item) {
            this.extraDesc.splice(item, 1)
        },

    },
    watch: {
        installment(val) {
            if (val) {
                this.final = false;
            } else {
                this.mainPrice = '';
                this.count = '';
                this.Acceptdescription = '';
                this.days = [];
            }
        },
        final(val) {
            if (val)
                this.installment = false
        },
        status(val) {
            if (val === 'accept')
                this.description = '';
        },
        days(val) {
            this.count = val.length
        }
    },
    computed: {
        countPrice() {
            return this.finalPrice = this.mainPrice / this.count
        },
        main_price: {
            get() {
                return this.$options.filters.currency(this.mainPrice)
            },
            set(value) {
                this.mainPrice = value.replaceAll(',', '')
            }
        },
        computeDays() {
            return this.archives.transactions.filter((val) => val.status === "pending").map(transition => transition.expired_at);
        },

    },
    mounted() {
        this.day();
        this.mainPrice = this.archives.remain_money;

        if (typeof this.archives.description === 'string' || this.archives.description === null)
            this.extraDesc.push({
                title: '',
                desc: this.archives.description
            });
        else {
            this.extraDesc = this.archives.description;
        }
    }
}
</script>

<style>
.fa-pencil-alt {
    font-size: 15pt !important;
}
</style>